function ZipCodeCheck(el) {
    this.el = el;
    this.input = this.el.querySelector('.jsZipCodeCheckInput');
    this.submitBtn = this.el.querySelector('.jsZipCodeCheckSubmitBtn');

    this.el.addEventListener('submit', e => {
        e.preventDefault();
        if (!this.input.value) return;

        this.submitBtn.classList.add('btn--loading');

        se_postRequest(se_ajax.ajaxurl, {
            action: 'get_commune_url_for_zipcode',
            zipcode: this.input.value
        }, response => {
            this.submitBtn.classList.remove('btn--loading');
            response = JSON.parse(response);

            if (response.err || !response.url) return alert('Oeps.. Er ging iets niet helemaal goed. Controleer de invoer en probeer het nogmaals.');
            window.location.href = response.url;
        }, err => {
            this.submitBtn.classList.remove('btn--loading');
            console.error(err);
            return alert('Oeps.. Er ging iets niet helemaal goed. Controleer de invoer en probeer het nogmaals.');
        });
    });
}

(function() {
    const zipCodeCheckEls = document.querySelectorAll('.jsZipCodeCheck');
    zipCodeCheckEls.forEach(el => new ZipCodeCheck(el));
})();
